'use client';

import type { FC, PropsWithChildren } from 'react';
import { createContext, useContext, useMemo, useState } from 'react';
import { getCurrentTime } from '../../../common/utils';
import { type MonthOptionType, toMonthOption } from './SalesRankingMonthSelector';
import { ORDER_BY_VALUES, type OrderByOption } from './SalesRankingOrderBySelector';

interface SalesRankingFilter {
  month: MonthOptionType;
  orderBy: OrderByOption['value'];
}

interface SalesRankingFilterContextType {
  filter: SalesRankingFilter;
  setFilter: (filter: SalesRankingFilter) => void;
}

const SalesRankingFilterContext = createContext<SalesRankingFilterContextType | null>(null);

export const SalesRankingFilterProvider: FC<PropsWithChildren> = ({ children }) => {
  const [filter, setFilter] = useState<SalesRankingFilter>(() => {
    const month: MonthOptionType = toMonthOption(getCurrentTime());
    const orderBy: OrderByOption['value'] = ORDER_BY_VALUES.누적_수수료_높은_순;

    return { month, orderBy };
  });

  const value = useMemo(() => ({ filter, setFilter }), [filter, setFilter]);

  return (
    <SalesRankingFilterContext.Provider value={value}>
      {children}
    </SalesRankingFilterContext.Provider>
  );
};

export const useSalesRankingFilter = () => {
  const context = useContext(SalesRankingFilterContext);
  if (!context) {
    throw new Error('useSalesRankingFilter must be used within a SalesRankingFilterProvider');
  }
  return context;
};
